export enum PaymentPartner {
  JusPay = 'juspay',
  BharatPe = 'bharatpe',
  RazorPay = 'razorpay',
  Payu = 'payu',
  CashFree = 'cashfree',
  Simpl = 'simpl',
  LazyPay = 'lazypay',
  Parkplus = 'parkplus',
  Cred = 'cred',
  Cash = 'cash',
}
